<template>
  <q-dialog v-model="dialog" persistent>
    <q-card>
      <q-card-section class="caution-dialog-title">
        会員登録にあたり、以下の点についてご確認をお願いいたします
      </q-card-section>
      <q-card-section>
        <p>
          ChemPandaは、掲載する製品の中から、在庫試薬・合成用試薬やバルク製品（開発品・商業品）などを直接ご使用になるお客様のご利用をお願いいたします。
        </p>
        <p>
          フリーメール等のご登録もお断りいたします。<br />
          (使用不可例 ： xxxxx@yahoo.co.jp, xxxxx@gmail.com)<br />
          所属企業・機関のドメインのメールアドレスをご使用ください。<br />
        </p>
      </q-card-section>
      <q-card-actions align="center">
        <q-btn color="primary" label="OK" style="width: 220px" @click="setDisplay" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import { ref } from 'vue';

interface Props {
  display: boolean | false;
}
const props = defineProps<Props>();

const dialog = ref(props.display);

const setDisplay = () => {
  dialog.value = false;
};
</script>
<style scoped>
.caution-dialog-title {
  color: var(--q-negative);
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
}
</style>
